import React, { useCallback, useEffect, useState } from "react";
import "./Toggle.scss";

export const Toggle = ({
  className = "",
  primaryColor = null,
  secondaryColor = null,
  values = ["A", "B"],
  selected = null,
  title = "",
  style = {},
  onChange = () => {},
}) => {
  const [value, setValue] = useState(selected || values[0]);

  // change state if selectedprop changes
  useEffect(() => {
    setValue(selected || values[0]);
  }, [selected, values]);

  const onValueChange = useCallback(
    (e) => {
      const newValue = e.target.dataset.value;
      setValue(newValue);
      onChange(newValue);
    },
    [onChange]
  );

  return (
    <div className={`${className}`} style={style}>
      <div className="flex flex-column items-start">
        {title && <div className="block-font mb1 uppercase">{title}</div>}
        <div className="toggle__container flex flex-row">
          {values.map((v) => (
            <div
              key={`toggle-value-${v}`}
              className={`toggle__item block-font pointer p1 px2 ${
                value === v && `selected`
              }`}
              onClick={onValueChange}
              data-value={v}
            >
              {v}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
